import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

interface AdjustContractDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  proposedContractEndDate: Date | null;
  onDateChange: (date: Date) => void;
  onSubmit: () => void;
  formatDateToISO: (date: Date | null) => string;
}

export function AdjustContractDialog({
  isOpen,
  onOpenChange,
  proposedContractEndDate,
  onDateChange,
  onSubmit,
  formatDateToISO
}: AdjustContractDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="glass-dialog w-100">
        <DialogHeader>
          <DialogTitle>Adjust Contract Renewal End Date</DialogTitle>
          <DialogDescription>
            Please select the new proposed contract end date. This will update the months for all product lines.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="proposed-contract-end-date">Renewal Contract End Date</Label>
            <Input
              id="proposed-contract-end-date"
              type="date"
              value={formatDateToISO(proposedContractEndDate)}
              onChange={(e) => onDateChange(new Date(e.target.value))}
              className="glass-input"
            />
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSubmit}>Submit</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
